import { AiDaySummary } from './ai-day-summary';

export class AiSummary {
   totalTasksInstanceLaunched: number = 0;
   lastAiRunDate: string = '';
   summaryResponses: AiDaySummary[] = [];
}
